import {Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {LogoComponent} from '../logo/logo.component';

@Component({
  selector: 'app-auth-layout',
  imports: [
    RouterLink,
    LogoComponent,
  ],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent {}
